<template>
<div class="chapter">
<div class="inner_page">
<div id="List_of_Illustrations">
<p class="fm-title1">List of Illustrations</p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_1" title="Link target outside of Sample">HMS <i>Achilles</i></span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_2" title="Link target outside of Sample">Rear Admiral Sydney Fremantle</span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_3" title="Link target outside of Sample">The memorial in Bodo</span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_4" title="Link target outside of Sample"><i>Changuinola</i></span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_5" title="Link target outside of Sample">Admiral Sir Dudley de Chair</span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_6" title="Link target outside of Sample"><i>Orvieto</i></span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_7" title="Link target outside of Sample">Busta Voe</span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_8" title="Link target outside of Sample">The Hillswick Hotel</span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_9" title="Link target outside of Sample">Map showing the basic operating areas of the Northern Patrol</span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_10" title="Link target outside of Sample"><i>Changuinola</i></span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_11" title="Link target outside of Sample"><i>Cedric</i></span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_3" title="Link target outside of Sample"><i>India</i></span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_12" title="Link target outside of Sample"><i>Carmania</i> sinking <i>Cap Trafalgar</i></span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_13" title="Link target outside of Sample">Dazzle painting</span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_14" title="Link target outside of Sample">4.7in guns</span></p>
<p class="noindent1"><span href="#/xhtml/25_Plates#fig_15" title="Link target outside of Sample"><i>Bayano</i>, before and during the war</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_List_of_Illustrations.vue?495c1986